import { component } from 'picoapp';

function BackToTop(el, ctx) {
  if (!el){
      return
  }

  function calculateTop(){
    const target = document.querySelector('[data-top-target]');
    const top = target ? target.offsetTop : 20;
    return top
  }

  window.addEventListener('resize', () => {
    calculateTop();
  })
   
  window.onscroll = () => {
    if (document.body.scrollTop > calculateTop() || document.documentElement.scrollTop > calculateTop()) {
        el.classList.add("is-visible");
    } else {
        el.classList.remove("is-visible");
    }
  }
  el.onclick = (e) => {
    e.preventDefault();
    document.documentElement.scrollTop = calculateTop();
  }
}

export default component((node, ctx) => {
    new BackToTop(node, ctx);
});
  